import { PageHeading } from "@/components/common/PageHeading.tsx";
import { CreateTenantDto, PatchTenantDto } from "@/models";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/useToast.tsx";
import { tenant as tenantActions } from "@/repositories/tenant.ts";
import { CreateEditTenantForm } from "@/components/forms/CreateEditTenant.form.tsx";

export const CreateTenantPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleOnSubmit = async (values: CreateTenantDto | PatchTenantDto) => {
    if ((values as PatchTenantDto).id) {
      return;
    }
    await tenantActions.create(values as CreateTenantDto).then((t) => {
      toast({
        title: "Tenant Created!",
        description: `${t.name} created successfully.`,
      });
      navigate("..");
    });
    return;
  };

  const handleCancel = async () => {
    navigate("..");
  };

  return (
    <div className="flex flex-col gap-4 m-auto">
      <PageHeading>Create a Tenant</PageHeading>
      <CreateEditTenantForm
        onSubmit={handleOnSubmit}
        onCancel={handleCancel}
        isEditable
      />
    </div>
  );
};
